module.exports = __webpack_public_path__ + "media/packs/static/fonts/interUI/medium-01ddf50384c3087b081dc806fb13b061.woff2";